// client/src/pages/RecruitList.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_API_URL}/api`;

export default function RecruitList() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await fetch(`${API}/opportunities`);
      const d = await res.json();
      setPosts(d.items || []);
    } catch (err) {
      console.error("Failed to load opportunities", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="min-h-screen p-6 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-5xl mx-auto bg-white dark:bg-slate-800 p-6 rounded-xl shadow">

        {/* BACK BUTTON ADDED */}
        <div className="flex items-center justify-between mb-4 dark:text-white">
          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1 border rounded"
          >
            ← Back
          </button>

          <h1 className="text-2xl font-bold dark:text-white">Opportunities</h1>

          <button
            onClick={() => navigate("/recruit/create")}
            className="px-4 py-2 bg-indigo-600 text-white rounded dark:text-white"
          >
            Create
          </button>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-3">
          {loading ? (
            <div className="dark:text-white">Loading…</div>
          ) : posts.length === 0 ? (
            <div className="text-slate-600 dark:text-slate-300">
              No opportunities yet.
            </div>
          ) : (
            posts.map((p) => (
              <div
                key={p._id}
                className="bg-slate-100 dark:bg-slate-900 p-4 rounded-lg shadow flex gap-4"
              >
                <div className="w-28 h-20 bg-white rounded overflow-hidden">
                  {p.imageUrl ? (
                    <img
                      src={p.imageUrl}
                      alt="item"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-slate-400">
                      No
                    </div>
                  )}
                </div>

                <div className="flex-1">
                  <h3 className="font-semibold dark:text-white">{p.title}</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">
                    {p.description?.slice(0, 120)}
                  </p>
                  <p className="text-xs text-slate-500 mt-2 dark:text-white">
                    Category: {p.category || "N/A"}
                  </p>
                </div>

                <div className="flex flex-col gap-2">
                  <button
                    onClick={() => navigate(`/recruit/${p._id}`)}
                    className="px-3 py-1 border rounded dark:text-white"
                  >
                    View
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
}
